import {
  CREATE_USER,
  CREATE_USER_SUCCESS,
  CREATE_USER_ERROR,
  AUTHENTICATE_USER,
  AUTHENTICATE_USER_SUCCESS,
  AUTHENTICATE_USER_ERROR,
  INIT_USER,
  INIT_USER_SUCCESS,
  INIT_USER_ERROR,
  RESET_USER,
  LOGOUT_USER,
  REFRESH_TOKENS,
  REFRESH_TOKENS_SUCCESS,
  REFRESH_TOKENS_ERROR,
  PASSWORD_FORGOTTEN_REQUEST,
  PASSWORD_FORGOTTEN_REQUEST_SUCCESS,
  PASSWORD_FORGOTTEN_REQUEST_ERROR,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_REQUEST_SUCCESS,
  RESET_PASSWORD_REQUEST_ERROR,
  GENERATE_TOKEN,
  GENERATE_TOKEN_SUCCESS,
  GENERATE_TOKEN_ERROR,
  GET_BASIC_ACCOUNT,
  GET_BASIC_ACCOUNT_ERROR,
  GET_BASIC_ACCOUNT_SUCCESS,
  SET_LOGON_UID,
  USERNAMES_FETCH,
  USERNAMES_FETCH_SUCCESS,
  USERNAMES_FETCH_ERROR,
  CREATE_PLAIN_USER,
  CREATE_PLAIN_USER_SUCCESS,
  CREATE_PLAIN_USER_ERROR,
  ENCRYPTED_EMAIL_FETCH,
  ENCRYPTED_EMAIL_FETCH_SUCCESS,
  DECRYPTED_EMAIL_FETCH,
  DECRYPTED_EMAIL_FETCH_SUCCESS,
  DECRYPTED_EMAIL_FETCH_ERROR,
  ENCRYPTED_EMAIL_FETCH_ERROR,
} from './userActionConstants';

export const createUser = (payload) => ({
  type: CREATE_USER,
  payload,
});

export const createUserSuccess = (payload) => ({
  type: CREATE_USER_SUCCESS,
  payload,
});

export const createUserError = (payload) => ({
  type: CREATE_USER_ERROR,
  payload,
});

export const authenticateUser = (payload) => ({
  type: AUTHENTICATE_USER,
  payload,
});

export const authenticateUserSuccess = (payload) => ({
  type: AUTHENTICATE_USER_SUCCESS,
  payload,
});

export const authenticateUserError = (payload) => ({
  type: AUTHENTICATE_USER_ERROR,
  payload,
});

export const initUser = (payload) => ({
  type: INIT_USER,
  payload,
});

export const initUserSuccess = (payload) => ({
  type: INIT_USER_SUCCESS,
  payload,
});

export const initUserError = (payload) => ({
  type: INIT_USER_ERROR,
  payload,
});

export const refreshTokens = (payload) => ({
  type: REFRESH_TOKENS,
  payload,
});

export const refreshTokensSuccess = (payload) => ({
  type: REFRESH_TOKENS_SUCCESS,
  payload,
});

export const refreshTokensError = (payload) => ({
  type: REFRESH_TOKENS_ERROR,
  payload,
});

export const resetUser = () => ({
  type: RESET_USER,
});

export const logoutUser = () => ({
  type: LOGOUT_USER,
});

// forgotten password
export const postPasswordForgottenRequest = (payload) => ({
  type: PASSWORD_FORGOTTEN_REQUEST,
  payload,
});

export const postPasswordForgottenRequestSuccess = (payload) => ({
  type: PASSWORD_FORGOTTEN_REQUEST_SUCCESS,
  payload,
});

export const postPasswordForgottenRequestError = (payload) => ({
  type: PASSWORD_FORGOTTEN_REQUEST_ERROR,
  payload,
});

// reset password
export const postResetPassword = (payload) => ({
  type: RESET_PASSWORD_REQUEST,
  payload,
});

export const postResetPasswordSuccess = (payload) => ({
  type: RESET_PASSWORD_REQUEST_SUCCESS,
  payload,
});

export const postResetPasswordError = (payload) => ({
  type: RESET_PASSWORD_REQUEST_ERROR,
  payload,
});

export const generateToken = (payload) => ({
  type: GENERATE_TOKEN,
  payload,
});

export const generateTokenSuccess = (payload) => ({
  type: GENERATE_TOKEN_SUCCESS,
  payload,
});

export const generateTokenError = (payload) => ({
  type: GENERATE_TOKEN_ERROR,
  payload,
});

// set account data
export const setLogonUid = (payload) => ({
  type: SET_LOGON_UID,
  payload,
});

// get basic account
export const getBasicAccount = (payload) => ({
  type: GET_BASIC_ACCOUNT,
  payload,
});

export const getBasicAccountError = (payload) => ({
  type: GET_BASIC_ACCOUNT_ERROR,
  payload,
});

export const setBasicAccount = (payload) => ({
  type: GET_BASIC_ACCOUNT_SUCCESS,
  payload,
});

export const fetchUsernames = ({
  email,
  token,
  setFieldError,
  setIsLoading,
  onSuccess,
  onError,
  encryptV1Email,
  formUserInvite,
}) => ({
  type: USERNAMES_FETCH,
  email,
  token,
  setFieldError,
  setIsLoading,
  onSuccess,
  onError,
  encryptV1Email,
  formUserInvite,
});

export const fetchUsernamesSuccess = (payload) => ({
  type: USERNAMES_FETCH_SUCCESS,
  payload,
});

export const fetchUsernamesError = (payload) => ({
  type: USERNAMES_FETCH_ERROR,
  payload,
});

export const createPlainUser = (payload) => ({
  type: CREATE_PLAIN_USER,
  payload,
});

export const createPlainUserSuccess = (payload) => ({
  type: CREATE_PLAIN_USER_SUCCESS,
  payload,
});

export const createPlainUserError = (payload) => ({
  type: CREATE_PLAIN_USER_ERROR,
  payload,
});

// encrypt V2 user email
export const fetchEncryptedEmail = (payload) => ({
  type: ENCRYPTED_EMAIL_FETCH,
  payload,
});

export const fetchEncryptedEmailSuccess = (payload) => ({
  type: ENCRYPTED_EMAIL_FETCH_SUCCESS,
  payload,
});

export const fetchEncryptedEmailError = (payload) => ({
  type: ENCRYPTED_EMAIL_FETCH_ERROR,
  payload,
});

// decrypt V2 user email
export const fetchDecryptedEmail = (payload) => ({
  type: DECRYPTED_EMAIL_FETCH,
  payload,
});

export const fetchDecryptedEmailSuccess = (payload) => ({
  type: DECRYPTED_EMAIL_FETCH_SUCCESS,
  payload,
});

export const fetchDecryptedEmailError = (payload) => ({
  type: DECRYPTED_EMAIL_FETCH_ERROR,
  payload,
});
